import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
import { PortraitFrame } from '../components/PortraitFrame';
import { metrics, profile } from '../data/site';
export function Home() {
  return <>
      <section className="w-full bg-ink-950 py-16 lg:py-24" data-id="element-167" data-mp="2x67n4tncrgr0">
        <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-168" data-mp="2x7sgwh1uevnt">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          ease: 'easeOut'
        }} className="lg:col-span-7" data-id="element-169" data-mp="1zkacfif7sfpm">
            <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-brass-400" data-id="element-170" data-mp="2dhgu19o7c8d9">
              {profile.title}
            </p>
            <h1 className="mt-6 font-display text-3xl leading-[1.18] text-ivory sm:text-4xl lg:text-[46px]" data-id="element-171" data-mp="3kuqw7be87xk5">
              Driving Healthcare Transformation at the Intersection of Medicine,
              AI, and Capital.
            </h1>
            <p className="mt-7 max-w-2xl text-base leading-relaxed text-slate-300" data-id="element-172" data-mp="2vxovrt9m1fne">
              Physician Executive, Chief Medical Officer, and Venture Advisor
              with 20+ years of experience scaling digital health solutions,
              optimizing clinical quality, and advising high-growth startups.
            </p>

            <div className="mt-10 flex flex-col gap-4 sm:flex-row" data-id="element-173" data-mp="2hy70qw5q165l">
              <Link to="/contact" className="group inline-flex items-center justify-center gap-2 bg-brass-500 px-7 py-4 font-display text-[13px] text-ink-950 transition-colors hover:bg-brass-400" data-id="element-174" data-mp="2d777q1zq388d">
                Request Strategic Advisory
                <ArrowRightIcon size={16} className="transition-transform group-hover:translate-x-1" data-id="element-175" data-mp="2376k43utm5yd" />
              </Link>
              <Link to="/experience" className="inline-flex items-center justify-center border border-white/25 px-7 py-4 font-display text-[13px] text-ivory transition-colors hover:border-brass-400 hover:text-brass-300" data-id="element-176" data-mp="1u94mzze7jxgd">
                View Experience & Credentials
              </Link>
            </div>

            <p className="mt-8 inline-flex items-center gap-2 text-[13px] text-slate-400" data-id="element-177" data-mp="1fl4b59cg3479">
              <MapPinIcon size={14} className="text-brass-400" data-id="element-178" data-mp="23bgsfatkydai" />
              {profile.locations}
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.97
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.55,
          delay: 0.12,
          ease: 'easeOut'
        }} className="lg:col-span-5" data-id="element-179" data-mp="28905i7ejkk0v">
            <PortraitFrame data-id="element-180" data-mp="2ma2scmdd1ycu" />
          </motion.div>
        </div>
      </section>

      <section aria-label="Key proof points" className="w-full border-b border-stone bg-ivory" data-id="element-181" data-mp="2m7zslameoqux">
        <dl className="mx-auto grid max-w-7xl grid-cols-1 divide-y divide-stone px-6 sm:grid-cols-2 sm:divide-y-0 lg:grid-cols-4 lg:divide-x lg:px-10" data-id="element-182" data-mp="flu3f7kemcjx">
          {metrics.map((metric, i) => <motion.div key={metric.label} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.07
        }} className="py-10 lg:px-8 lg:first:pl-0" data-id="element-183" data-mp="akwiwobx96f9" data-mpi={i}>
              <dt className="sr-only" data-id="element-184" data-mp="3nu0wwdp6dmbk">{metric.label}</dt>
              <dd data-id="element-185" data-mp="3nvlvqfiivrf8">
                <span className="block font-display text-3xl text-ink-950 lg:text-4xl" data-id="element-186" data-mp="5ne78q6isd3k">
                  {metric.value}
                </span>
                <span className="mt-2 block text-[12px] font-semibold uppercase tracking-[0.14em] text-graphite" data-id="element-187" data-mp="n01jese5f8p">
                  {metric.label}
                </span>
              </dd>
            </motion.div>)}
        </dl>
      </section>
    </>;
}